import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ImNew from "./pages/ImNew";
import Events from "./pages/Events";
import WatchLive from "./pages/WatchLive";
import Sermons from "./pages/Sermons";
import Media from "./pages/Media";
import PrayerRequest from "./pages/PrayerRequest";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Leadership from "./pages/Leadership";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/im-new" element={<ImNew />} />
            <Route path="/events" element={<Events />} />
            <Route path="/watch-live" element={<WatchLive />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/media" element={<Media />} />
            <Route path="/prayer-request" element={<PrayerRequest />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/leadership" element={<Leadership />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
